var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56585 26.5671C7.56585 26.5671 10.575 22.725 18 22.725C25.425 22.725 28.4355 26.5671 28.4355 26.5671M18 4.5C10.544 4.5 4.5 10.544 4.5 18C4.5 25.456 10.544 31.5 18 31.5C25.456 31.5 31.5 25.456 31.5 18C31.5 10.544 25.456 4.5 18 4.5ZM18 18C19.0741 18 20.1043 17.5733 20.8638 16.8138C21.6233 16.0543 22.05 15.0241 22.05 13.95C22.05 12.8759 21.6233 11.8457 20.8638 11.0862C20.1043 10.3267 19.0741 9.9 18 9.9C16.9259 9.9 15.8957 10.3267 15.1362 11.0862C14.3767 11.8457 13.95 12.8759 13.95 13.95C13.95 15.0241 14.3767 16.0543 15.1362 16.8138C15.8957 17.5733 16.9259 18 18 18Z",
    stroke: "#85909F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.492e7e5169d9a78889126e09d72f701a.svg";
export { ForwardRef as ReactComponent };